import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";
import { v4 as uuidv4 } from 'uuid';

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function GetAccidentCountReport(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport
  };
  return client.post("Reports/GetAccidentCountReport", prepareRequest(data));
}

function GetBtzAccidentsReport(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText,
    PaymentStatus: item.paymentStatus,
    AccidentStatus: item.accidentStatus,
    ClaimStatus: item.claimStatus,
    ZbtStatus: item.zbtStatus,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport
  };
  return client.post("Reports/GetBtzAccidentsReport", prepareRequest(data));
}

function GetAccidentsClaimStatusReport(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate
  };
  return client.post("Reports/GetAccidentsClaimStatusReport", prepareRequest(data));
}

function GetAccidentDetails(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport
  };
  return client.post("Reports/GetAccidentDetails", prepareRequest(data));
}

function GetAccidentDetailsFull(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport
  };
  return client.post("Reports/GetAccidentDetailsFull", prepareRequest(data));
}

export {
  GetAccidentCountReport,
  GetBtzAccidentsReport,
  GetAccidentsClaimStatusReport,
  GetAccidentDetails,
  GetAccidentDetailsFull
};